import { useLocation, useNavigate } from 'react-router';

import { useCurrentUserContext } from 'contexts/currentUser';
import { WalletTab, useWalletDrawerContext } from 'contexts/walletDrawer';
import { useQueryString } from 'hooks/useQueryString';

export const usePromptAddFundsEth = () => {
  const { currentUser } = useCurrentUserContext();

  const { showDrawer, mounted, setCurrentTab, currentTab } =
    useWalletDrawerContext();
  const action = useQueryString('action');
  const location = useLocation();
  const navigate = useNavigate();

  if (
    action !== 'addFundsEth' ||
    !mounted ||
    !currentUser ||
    currentTab === WalletTab.ADD_FUNDS_TO_CRYPTO_WALLET_CRYPTO
  ) {
    return;
  }
  setCurrentTab(WalletTab.ADD_FUNDS_TO_CRYPTO_WALLET_CRYPTO);
  showDrawer();

  navigate(location.pathname, { replace: true });
};
